import grShelfLifeReport from "./report/grShelfLife";
export default {
  namespaced: true,
  modules: {
    grShelfLifeReport: grShelfLifeReport,
  },
};
